import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
@Component({
  selector: 'app-signaturetab',
  templateUrl: './signaturetab.component.html',
  styleUrls: ['./signaturetab.component.scss']
})
export class SignaturetabComponent implements OnInit {
  signatureText: string = `By checking the box below, you are certifying the following:`
  agreeText: string = `I intend and agree that the electronic submission of the information set forth herein constitutes my signature of the exemption registration.`
  @Input()
  SignatureTab!: FormGroup;

  constructor(
    private formBuilder: FormBuilder
  ) {
    // this.signatureTabs = this.formBuilder.group({
    //   firstName: ['', [Validators.required, Validators.maxLength(50)]],
    //   lastName: ['', [Validators.required, Validators.maxLength(50)]],
    //   certifyCheck : ['', [Validators.required]],
    // });
  }

  ngOnInit(): void {
  }
 getICertify() {
  return this.SignatureTab.controls['iCertify'].invalid;
 }
}
